/*
 This module has the primary function be a list of entrypoints (in our case: page modules) for the almond build,
 defining all the leaf nodes of the dependency tree that r.js will follow to the roots to figure out what to
 including in the bundle.

 In other words, if a leaf node is not listed here, it will not be included in the bundle and then be missing
 in production (and other bundle-based deployment configurations) at runtime.
 */

// Import polyfills based on browserslist. It will be transformed to direct module imports by Babel.
import "core-js/stable";
import "regenerator-runtime/runtime";

import $ from 'jquery';
import './commons';

(async () => {
    console.log('Page module: ' + pageModule);

    if (pageModule) {
        /**
         * Dynamic imports in our case are kinda tricky.
         *
         * `webpackMode` tells to bundle everything into the core JS file.
         *
         * `webpackInclude` tells to include files that matches regexp ONLY.
         * Without it webpack tries to include ALL JavaScript files in the project.
         *
         * `root` is an alias which points to the root folder of the project.
         */
        const { default: page} = await import(
            /* webpackMode: "eager" */
            /* webpackInclude: /[\w-_]+\/static\/js\/app\/[\w-_]+\/.*\.js$/ */
            `root/${pageModule.replace(/app\/(.*)\/(.*)/, "$1/static/js/app/$1/$2.js")}`
        );

        if (!page) {
            console.error(`Could not find requested page module: ${pageModule}`);
        } else {
            $(document).ready(page.init);
        }
    }
})();
